import React, { useState, useEffect, useCallback } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Typography, CircularProgress, Button } from "@material-ui/core";
import { _activateUser } from "../../apis/user";
import { useLocation, useHistory } from "react-router-dom";

const useStyle = makeStyles((theme: Theme) => ({
  viewBg: {
    height: "100vh",
    backgroundColor: "#E5EAEE",
  },
  middle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  center: { display: "flex", justifyContent: "center", position: "relative" },
  circleProcess: { position: "absolute", top: 70 },
  fixTop: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
  },
  fullHeight: { height: "100%" },
}));

const Activate = () => {
  const classes = useStyle();
  const [message, setmessage] = useState("กำลังยืนยันบัญชีของคุณ");
  const [message2, setmessage2] = useState("โปรดรอสักครู่");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const activeuser = useCallback(async () => {
    const searchText = location.search;
    const codeParam = new URLSearchParams(searchText).get("code");
    const emailParam = new URLSearchParams(searchText).get("email");
    const input = { email: emailParam, activate_code: codeParam };

    if (typeof codeParam === "string") {
      const active = await _activateUser(input);
      console.log(active);
      if (active.status.code === 200) {
        setTimeout(() => {
          setmessage("ยืนยันบัญชีของคุณเรียบร้อยแล้ว");
          setmessage2("");
          setLoading(true);
        }, 2000);
      } else {
        setTimeout(() => {
          setmessage("บัญชีของคุณถูกยืนยันแล้ว");
          setmessage2("");
          setLoading(true);
        }, 2000);
      }
    } else {
      history.replace("/auth/signin");
    }
  }, [location, history]);

  useEffect(() => {
    activeuser();
    return () => {};
  }, [activeuser]);

  return (
    <div className={clsx(classes.middle, classes.viewBg)}>
      <div className={classes.center}>
        <div style={{ marginTop: "1rem" }}>
          <Typography align="center">{message}</Typography>
          {!loading ? <Typography align="center">{message2}</Typography> : null}
        </div>
        {loading ? (
          <div className={classes.circleProcess}>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={() => {
                history.replace("/auth/signin");
              }}
            >
              เข้าสู่ระบบ
            </Button>
          </div>
        ) : null}
        {!loading ? (
          <CircularProgress
            className={classes.circleProcess}
            size={50}
            thickness={2}
            color="primary"
          />
        ) : null}
      </div>
    </div>
  );
};

export default Activate;
